import { render, staticRenderFns } from "./update-order-statu.vue?vue&type=template&id=da0da4d6&"
import script from "./update-order-statu.vue?vue&type=script&lang=ts&"
export * from "./update-order-statu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports